import { cn } from '@/lib/utils'
import type { SVGProps } from 'react'
export const MariaDBLogo = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 256 170"
    className={cn('dark:brightness-[1.1]', className)}
    {...props}
  >
    <path
      d="M250.4 0c-4 .1-2.7 1.3-11.3 3.4-8.6 2.1-19.1 1.4-28.4 5.3-27.8 11.7-33.4 51.5-58.6 65.7-18.9 10.7-37.9 11.5-55 16.9a100.6 100.6 0 0 0-33.7 19.5c-8 6.8-8.1 12.8-16.4 21.4-8.8 9.1-35 .1-47 14.1 3.8 3.9 5.5 5 13 4-1.5 3-10.7 5.4-9 9.8 2 4.6 24.3 7.7 44.6-4.5 9.4-5.7 17-14 31.7-16 19-2.5 41 1.7 63 4.9-3.3 9.7-9.9 16.2-15.1 24-1.7 1.7 3.2 2 8.8.9 10-2.5 17.3-4.5 24.9-9 9.3-5.4 10.7-19.3 22.1-22.3 6.4 9.8 23.7 12.1 34.5 4.3-9.4-2.7-12-22.8-8.9-31.6 3-8.4 6-21.8 9-32.8 3.3-12 4.5-26.9 8.5-33 6-9 12.5-12.2 18.2-17.3 5.7-5.2 10.9-10.2 10.7-22 0-3.7-2-5.8-5.6-5.7Z"
      fill="#002B64"
    />
    <path
      d="M242 7c.9 3.2 2.3 4.7 8.8 5.3-1 8.1-6.4 12.6-12.5 16.8-5.3 3.8-11.2 7.4-15 13.3-3.8 6-6.3 26.5-12.3 46.8-5.1 17.5-13 34.9-26.6 42.5-1.4-3.6.2-10.2-2.6-12.4-1.9 5.2-4 10.2-6.4 14.9a53.2 53.2 0 0 1-39.6 30.2c9.4-12.7 18.3-25.8 18.5-47.7-6.6 1.4-6.4 17-13.2 21.2-4.4.5-8.8.5-13.2.2-18.3-1.1-37-6.6-54-1.1-11.7 3.7-21.2 12.5-31 16.8-11.6 5-20.3 7-34.7 5-1.9-2.5 10.5-5.6 9.8-11-5.7-.6-9 .7-13.8-1.5.5-1 1.3-1.8 2.3-2.5 9-6.2 34.5-1.5 41.3-8.2 4.2-4.1 7-8.4 9.8-12.6A51.2 51.2 0 0 1 73 107.4c7.4-5 16.6-9.7 25.7-12.9 12.4-4.3 24.9-4.7 38-9.7 8.2-3.1 17-7 24.2-12.3 1.7-1.3 3.4-2.7 4.9-4.1 20.6-20 24.6-55.5 56.7-58.8 4-.4 7.1-.2 10-.3 3.3-.1 6.3-.5 9.5-2.3Zm-39.2 113.3c.3 6.1 3.9 18.3 7 21.2-6.1 1.5-16.7-1-19.4-5.3 1.4-6.3 8.6-12 12.4-16Z"
      fill="#C49A6C"
    />
    <path
      d="M244.2 13.8c-1.2 2.6-3.6 6-3.6 12.6 0 1.1-.9 1.9-.9.2.1-6.5 1.8-9.3 3.6-13 .9-1.5 1.4-.9 1 .2Zm-1.2-1c-1.5 2.5-5 7-5.6 13.6 0 1.2-1 1.9-.9.1.7-6.4 3.5-10.4 5.6-14 1-1.3 1.4-.7.9.4Zm-1.2-1.2c-1.6 2.3-7 7.7-8.2 14.2-.2 1.2-1.1 1.8-.9 0 1.2-6.3 5.9-11.3 8.3-14.6 1-1.3 1.5-.6.8.4Zm-1-1.5-.5.6c-2.4 2.6-8 9-10 14.7-.3 1-1.4 1.6-.8-.1 2-6.1 7.7-12.7 10.5-15.7 1.3-1.1 1.6-.4.8.5Zm-29 13.1c1.2-5.4 5.4-7.8 12.6-7.2 1.8 8-8 11.3-12.6 7.2Z"
      fill="#002B64"
    />
  </svg>
)
